<template>
  <icon
    name="mdi-account-group"
    :size="size"
    :color="color"
  />
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Icon from "@/core/components/icon/Icon.vue";

export default defineComponent({
    name: "HealthcenterGroupIcon",
    components: {Icon},
    props: {
        size: {
            type: Number,
            default: 40
        },
        color: {
            type: String,
            default: 'black'
        }
    }
});
</script>

<style scoped>

</style>
